import moment from 'moment'
import {Company} from 'src/services/api'
import {Lpr} from 'src/services/api/endpoints/LprEndpoint'

const renderValueColumn = (optionHarpia: boolean, optionSpia: boolean, optionSivana: boolean, optionAspide: boolean, optionMuralhaPaulista: boolean) => {
  const valuesToRender = []
  if (optionHarpia) valuesToRender.push('Harpia')
  if (optionSpia) valuesToRender.push('Spia')
  if (optionSivana) valuesToRender.push('Sivana')
  if (optionAspide) valuesToRender.push('Áspide')
  if (optionMuralhaPaulista) valuesToRender.push('Muralha Paulista')

  return valuesToRender
}

export function lprEventRow(lpr: Lpr[], companies: Company[]) {
  return lpr.map((it) => {
    const createdDate = moment(it.createdAt).format('DD/MM/YYYY HH:mm:ss')
    const companyId = it.camera.companyId
    const companyName = companies.find((company) => company.id === companyId)?.name || ''
    const dispatchToSivanaWithSuccess = it.sentToSivana === 0
    return {
      id: it.id,
      camera: it.camera.name,
      company: companyName,
      dateTime: createdDate.toLocaleString(),
      plate: it.plate.licensePlate,
      fullImageKey: it.imageAwsKey,
      croppedImageKey: it.croppedImageAwsKey,
      brand: it.plate.vehicle?.brand ?? '-',
      model: it.plate.vehicle?.model ?? '-',
      color: it.plate.vehicle?.color ?? '-',
      sentTo: renderValueColumn(it.sentToHarpia, it.sentToSpia, dispatchToSivanaWithSuccess, it.sentToAspide, it.sentToMuralhaPaulista).join(', ') || '-',
      self: it,
      show: it.id,
    }
  })
}
